// shared/guards/feature.guard.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { AuthService } from 'app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuard implements CanActivate {
  constructor(
    private readonly featureFlagsService: FeatureFlagsService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Required, do not remove: initial navigation and the auth app initializer run
    // concurrently (see appConfig), so this await is what makes routing wait for auth
    // to settle. Without it the guard reads an unauthenticated service on cold start.
    await this.authService.ready;

    await this.featureFlagsService.ensureFeatureFlagsLoaded();

    // Check feature flag from route data
    const featureFlag = route.data?.['featureFlag'];
    if (featureFlag) {
      return this.checkFeatureFlag(featureFlag);
    }
    return true;
  }

  private checkFeatureFlag(featureFlag: string): boolean {
    const isEnabled = this.featureFlagsService.isFeatureEnabled(featureFlag);

    if (!isEnabled) {
      // Redirect to home if feature is disabled
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
